<template>
  <el-config-provider :locale="$store.getters.language === 'zh' ? zhCN : enUS">
    <router-view></router-view>
  </el-config-provider>
</template>

<script setup>
import zhCN from 'element-plus/lib/locale/lang/zh-cn'
import enUS from 'element-plus/lib/locale/lang/en'

import { useStore } from 'vuex'
import { generateNewStyle, writeNewStyle } from '@/utils/theme'

const store = useStore()

generateNewStyle(store.getters.mainColor).then((newStyleText) => {
  writeNewStyle(newStyleText)
})
</script>

<style></style>
